

































import Vue from "vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"

export default Vue.extend({
  components: {
    ConversionButton,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    supplement: {
      type: String,
      default: null,
    },
    isDrawnButton: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: null,
    },
    isAlignCenterOnPc: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClickButton() {
      this.$emit("click-button")
    },
  },
})
